<script lang="ts">
    import { getContents, getTags } from "../api"
    import { apiBaseURL } from "../config"
    import { i18n, sprache } from "../store"
    import Teaseritem from "./Teaseritem.svelte"
    import { debounce } from "lodash"

    let teaser: Content[] = []
    let projectSections: Tag[] = []

    export let sortby: string
    export let orderby: string
    export let buttontext: string
    export let buttonlink: string
    export let filtertags = []
    export let template: string
    export let limit: number
    export let showFilter: string
    export let title: string
    export let subtitle: string

    let limitView = 9
    let loadingNews = false
    let newsFilter = []

    if (orderby == "desc") {
        sortby = "-" + sortby
    }

    let projectSectionTagId = ""

    const loadNewsDebounced = debounce(loadNews, 500)

    async function loadMediaTags() {
        projectSections = await getTags("projectSection")
    }

    async function loadNews() {
        loadingNews = true
        limitView = 9

        /* console.log("loading news") */

        let tags = [projectSectionTagId].filter((tag) => tag)
        /* console.log(tags) */

        if (!tags.length && !projectSections?.length) {
            teaser = []
            loadingNews = false
            return
        }

        /* add tags to filter array */
        if (tags.length) {
            newsFilter = filtertags.concat(tags)
            /* console.log("tag", tags[0]) */
        } else {
            newsFilter = filtertags
        }

        /* console.log("filtertags", filtertags) */

        const _news = await getContents($sprache, null, null, limit, "list", null, newsFilter, "-date")
        teaser = _news
        loadingNews = false
    }

    loadMediaTags()

    if (showFilter) {
        if (typeof window !== "undefined") {
            window.addEventListener(
                "scroll",
                () => {
                    const { scrollTop, scrollHeight, clientHeight } = document.documentElement

                    if (scrollTop + clientHeight >= scrollHeight - 5 && teaser.length > limitView) {
                        limitView += 9
                    }
                },
                {
                    passive: true,
                }
            )
        }
    }

    $: if (!showFilter && !loadingNews) {
        getContents($sprache, null, null, limit, "list", null, filtertags, sortby).then((r: Content[]) => {
            teaser = r
        })
    }

    $: if (/* projectSections?.length ||*/ projectSectionTagId || showFilter) {
        loadNewsDebounced()
    } else {
        teaser = []
    }
</script>

{#if showFilter}
    <div class="row filter-row">
        {#if title}<h2>
                {title}
                {#if !subtitle}<div class="pulse"></div>{/if}
            </h2>
        {/if}
        {#if subtitle}<h3>{subtitle}</h3>{/if}
        <div class="filter">
            <label for="projektabschnitt">Filter Projektabschnitt</label><select
                name="projektabschnitt"
                id="projektabschnitt"
                bind:value="{projectSectionTagId}"
                ><option value="" selected>Alle</option>{#each projectSections as tag}
                    <option value="{tag.id}">{tag.name && tag.name[$sprache]}</option>
                {/each}</select
            >
        </div>
    </div>
{/if}
{#if showFilter}
    {#if loadingNews}
        lade...
    {:else if teaser.length == 0}
        <p>Keine Einträge gefunden</p>
    {:else}
        <div class="grid {template}">
            {#each teaser.slice(0, limitView) as item}
                <Teaseritem template="{template}" item="{item}" />
            {/each}
        </div>
        {#if buttontext}
            <div class="centered"><a href="{buttonlink}" class="centered border cta">{buttontext}</a></div>
        {/if}
    {/if}
{:else}
    <div class="grid {template}">
        {#each teaser as item}
            <Teaseritem template="{template}" item="{item}" />
        {/each}
    </div>
    {#if buttontext}
        <div class="centered"><a href="{buttonlink}" class="centered border cta">{buttontext}</a></div>
    {/if}
{/if}
